module.exports = __webpack_public_path__ + "img/929-2bb602.png";